import _clone from "lodash/clone"
import _forEach from "lodash/forEach"

const initialState = {
  user: {},
  userLanguages: [],
  userCareers: [],
  notifications: [],
  otherUser: {},
  favoriteJobs: {
    results: [],
    count: 0
  },
  casualMeetJobs: {
    results: [],
    count: 0
  },
  appliedJobs: {
    results: [],
    count: 0
  },
  hiddenJobs: {
    results: [],
    count: 0
  },
  unprocessedOffers: []
}

export default {
  namespaced: true,
  state: _clone(initialState),
  getters: {
    user(state) {
      return state.user;
    },
    userCandidate(state) {
      return state.userCandidate;
    },
    userLanguages(state) {
      return state.userLanguages;
    },
    userCareers(state) {
      return state.userCareers;
    },
    notifications(state) {
      return state.notifications
    },
    otherUser(state) {
      return state.otherUser
    },
    favoriteJobs(state) {
      return state.favoriteJobs;
    },
    casualMeetJobs(state) {
      return state.casualMeetJobs;
    },
    appliedJobs(state) {
      return state.appliedJobs;
    },
    hiddenJobs(state) {
      return state.hiddenJobs;
    },
    countUnReadOffers(state) {
      return state.unprocessedOffers.filter(offer => !offer.isRead).length
    }
  },
  mutations: {
    mergeUser(state, payload) {
      state.user = payload.user;
      state.userCandidate = payload.user.candidate || {
          isReceiveMail: true
      };
      state.userLanguages = state.userCandidate.languages || [];
      state.userCareers = state.userCandidate.careers || [];
    },
    mergeUserCandidate(state, payload) {
      state.userCandidate = payload.userCandidate;
      state.user = {...state.user, candidate: payload.userCandidate};
    },
    mergeUserCandidateLanguages(state, payload) {
      state.userLanguages = payload.languages || [];
    },
    mergeUserCandidateCareers(state, payload) {
      state.userCareers = payload.careers || [];
    },
    setOtherUser(state, payload) {
      state.otherUser = payload.user;
    },
    setIcon(state, payload) {
      state.user = {...state.user, iconUrl: payload.icon};
    },
    setCandidateIcon(state, payload) {
      state.userCandidate = {...state.userCandidate, imageUrl: payload.icon};
    },
    setNotifications(state, payload) {
      state.notifications = payload.notifications
    },
    setNotificationsIsRead(state, payload) {
      const notifications = _clone(state.notifications);
      _forEach(notifications, notif => notif.isRead = payload.isRead);
      state.notifications = notifications;
    },
    setFavoriteJobs(state, payload) {
      state.favoriteJobs = payload.jobs;
    },
    setCasualMeetJobs(state, payload) {
      state.casualMeetJobs = payload.jobs;
    },
    setAppliedJobs(state, payload) {
      state.appliedJobs = payload.jobs;
    },
    setHiddenJobs(state, payload) {
      state.hiddenJobs = payload.jobs;
    },
    clearData(state) {
      state.user = _clone(initialState.user);
      state.userCandidate = _clone(initialState.userCandidate);
      state.userLanguages = _clone(initialState.userLanguages);
      state.favoriteJobs = _clone(initialState.favoriteJobs);
      state.casualMeetJobs = _clone(initialState.casualMeetJobs);
      state.appliedJobs = _clone(initialState.appliedJobs);
      state.hiddenJobs = _clone(initialState.hiddenJobs);
    },
    setUnprocessedOffers(state, {offers}) {
      state.unprocessedOffers = offers
    }
  },
  actions: {
    updateUser({commit}, {user}) {
      commit("mergeUser", {user: user})
    },
    updateUserCandidate({commit}, {userCandidate}) {
      commit("mergeUserCandidate", {userCandidate: userCandidate})
    },
    updateUserCandidateLanguages({commit}, {languages}) {
      commit("mergeUserCandidateLanguages", {languages: languages})
    },
    updateUserCandidateCareers({commit}, {careers}) {
      commit("mergeUserCandidateCareers", {careers: careers})
    },
    updateOtherUser({commit}, {user}) {
      commit("setOtherUser", {user: user})
    },
    updateIcon({commit}, {icon}) {
      commit("setIcon", {icon: icon})
    },
    updateCandidateIcon({commit}, {icon}) {
      commit("setCandidateIcon", {icon: icon})
    },
    updateNotifications({commit}, {notifications}) {
      commit("setNotifications", {notifications: notifications})
    },
    updateNotificationsIsRead({commit}) {
      commit("setNotificationsIsRead", {isRead: true});
    },
    updateFavoriteJobs({commit}, {jobs}) {
      commit("setFavoriteJobs", {jobs: jobs});
    },
    updateCasualMeetJobs({commit}, {jobs}) {
      commit("setCasualMeetJobs", {jobs: jobs});
    },
    updateAppliedJobs({commit}, {jobs}) {
      commit("setAppliedJobs", {jobs: jobs});
    },
    updateHiddenJobs({commit}, {jobs}) {
      commit("setHiddenJobs", {jobs: jobs});
    },
    clearUser({commit}) {
      commit("clearData");
    },
    updateUnprocessedOffers({commit}, {offers}) {
      commit("setUnprocessedOffers", {offers})
    }
  }
}
